import type { MouseEvent } from 'react'

export const createRipple = (
  event: MouseEvent<HTMLElement>,
  rippleClassName: string | undefined
) => {
  const element = event.currentTarget
  const rect = element.getBoundingClientRect()
  const size = Math.max(rect.width, rect.height)
  const x = event.clientX - rect.left - size / 2
  const y = event.clientY - rect.top - size / 2

  const ripple = document.createElement('span')
  ripple.className = rippleClassName ?? ''
  ripple.style.width = ripple.style.height = `${size}px`
  ripple.style.left = `${x}px`
  ripple.style.top = `${y}px`

  element.appendChild(ripple)

  ripple.addEventListener('animationend', () => {
    ripple.remove()
  })
}
